import { messageRequest } from '@services'
import { deepCopy } from '@utils/basicUtil'
import { Notify } from 'vant'
export default {
  namespaced: true,
  state: {
    tableData: [],
    query: {
      current: 1,
      size: 25
    },
    total: 0
  },
  actions: {
    async getTableData ({ commit, state }, tabsValue) {
      const query = { ...state.query }
      const table = deepCopy(state.tableData)
      const res = await messageRequest.message.getMessageList({
        ...query,
        msgType: tabsValue
      })
      try {
        if (res.success && res.result) {
          await commit('setTotal', res.result.total || 0)
          await commit('setTableData', table.concat(res.result.records || []))
        } else {
          Notify({ type: 'danger', message: res.message })
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  mutations: {
    setTableData (state, tableData) {
      state.tableData = tableData
    },
    setQuery (state, { field, value }) {
      state.query = {
        ...state.query,
        [field]: value
      }
    },
    setTotal (state, total) {
      state.total = total
    }
  }
}
